import { render, staticRenderFns } from "./xshyItem.vue?vue&type=template&id=c50a8484&scoped=true"
import script from "./xshyItem.vue?vue&type=script&lang=js"
export * from "./xshyItem.vue?vue&type=script&lang=js"
import style0 from "./xshyItem.vue?vue&type=style&index=0&id=c50a8484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50a8484",
  null
  
)

export default component.exports